// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"68d51a35","82":"68d51a35","134":"68d51a35","400":"68d51a35","534":"68d51a35","742":"68d51a35","760":"68d51a35","805":"68d51a35","843":"68d51a35","850":"68d51a35"}[chunkId] + ".chunk.css";
};